import { render, staticRenderFns } from "./TablePaginationProps.vue?vue&type=template&id=531915de&scoped=true"
import script from "./TablePaginationProps.vue?vue&type=script&lang=js"
export * from "./TablePaginationProps.vue?vue&type=script&lang=js"
import style0 from "./TablePaginationProps.vue?vue&type=style&index=0&id=531915de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531915de",
  null
  
)

export default component.exports